import '@fortawesome/fontawesome-free/css/all.min.css'
import App from 'App'
import 'assets/plugins/nucleo/css/nucleo.css'
import 'assets/scss/argon-dashboard-react.scss'
import React from 'react'
import ReactDOM from 'react-dom'

ReactDOM.render(<App />, document.getElementById('root'))
